<div class="container">
<div class="d-flex gap-1">

  <mat-form-field appearance="outline" >
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input  [rangePicker]="picker">
      <input matStartDate [(ngModel)]="start" placeholder="Start date">
      <input matEndDate [(ngModel)]="end" placeholder="End date">
    </mat-date-range-input>
    <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>

    <!--            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>-->
    <!--            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>-->

  </mat-form-field>&nbsp;

<mat-form-field appearance="outline">
  <mat-label>Select Centre</mat-label>
  <mat-select [(ngModel)]="selectedCentre">
    <mat-option [value]="{centreName:'All Centre',centreCode:'All'}">All Centres</mat-option>
    <mat-option  *ngFor ='let c of centres$|async' [value]="c">{{c.centreName}} </mat-option>
  </mat-select>
</mat-form-field>
  <mat-form-field appearance="outline">
  <mat-label>Assessment Type</mat-label>
  <mat-select [(ngModel)]="selectedAssessmentType" (ngModelChange)="filterData()">
    <mat-option value="All">All </mat-option>
    <mat-option  *ngFor ='let type of assessmentTypes' [value]="type">{{type}} </mat-option>
  </mat-select>
</mat-form-field>


  <button mat-mini-fab color="accent" (click)="search()"  ><mat-icon>search</mat-icon></button>
  <button mat-mini-fab color="accent" (click)="clearAll()"><mat-icon>clear</mat-icon></button>
</div>
  <section class="card">

  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Education Follow-Up Assessment </h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">



      <li class="me-2">
        <button   mat-mini-fab color="primary" (click)="OpenDialog()" permission="Follow Up Assessment" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
          <mat-icon class="col-white" >add</mat-icon>
        </button>
      </li>

      <li>
        <button
          mat-mini-fab color="accent"
          (click)="downloadExcel()">
          <mat-icon>download</mat-icon>
        </button>
      </li>
      <!--      <li>-->
      <!--        <div class="export-button m-l-10" matTooltip="XLSX">-->
      <!--          <img src="assets/images/icons/xlsx.png" alt=""/>-->
      <!--        </div>-->
      <!--      </li>-->
    </ul>
  </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

  <table mat-table [dataSource]="dataSource" class="  example-container">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="sr.no">
      <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
      <td mat-cell *matCellDef="let element; let i=index"> {{i+1}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="children">
      <th mat-header-cell *matHeaderCellDef>Name </th>
      <td mat-cell *matCellDef="let element" >{{element.childName}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="centre">
      <th mat-header-cell *matHeaderCellDef> Centre </th>
      <td mat-cell *matCellDef="let element">{{element.centreName}} </td>
    </ng-container>
    <ng-container matColumnDef="sessionType">
      <th mat-header-cell *matHeaderCellDef> Type </th>
      <td mat-cell *matCellDef="let element">{{element.sessionType}} </td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let element" ><span *ngIf="element.date">{{element.date?.toDate()|date:'dd-MM-yyyy'}} </span></td>
    </ng-container>


    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" permission="Follow Up Assessment" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]" (click)="viewDialog(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>
        <button mat-icon-button color="primary" permission="Follow Up Assessment" [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]" (click)="viewEdit(element)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
        <button  mat-icon-button color="warn"  permission="Follow Up Assessment" [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]" (click)="deleteChild(element)" matTooltip="Delete"><mat-icon>delete</mat-icon></button>

      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]"
                 showFirstLastButtons
                 aria-label="Select page">
  </mat-paginator>
</section>
</div>
